import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Button, message } from "antd";
import List from "../../../Commons/BasicModule/List";
import { getCyclesRequest, getCyclesState } from "../../../Stores/CycleSlice";
import { CheckCircleTwoTone, CloseCircleOutlined } from '@ant-design/icons';

// No Edit 
const tableField = ['id','payment_time', 'payment_type', 'cycle_name', 'next_balance', 'payment_amount', 'cashback', 'payment_status', 'previous_balance',]
const columnTable = tableField.map((field) => ({
    title: field.replace(/_/g, ' ').toUpperCase(),
    dataIndex: field,
    key: field,
    render: (text, record) => {
        if (field === 'id') {
            return (
                <Button
                    type="link"
                    onClick={() => {
                        navigator.clipboard.writeText(text)
                        message.success('ID copied to clipboard')
                    }}
                >
                    {text}
                </Button>
            )
        }
        if (field === 'payment_status') {
            return text === 'success' ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CloseCircleOutlined style={{ color: 'red' }} />
        }
        return text;
    }
}))

const customColumn = [...columnTable]

const PaymentComponent = ({ data }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const cyclesData = useSelector(getCyclesState);
    const [dataTable, setDataTable] = useState([]);
    
    useEffect(() => {
        dispatch(getCyclesRequest());
    }, [dispatch])

    useEffect(() => {
        let payments = data.data.payments.map(payment => ({ ...payment }));
        // Sort payments by created_at
        payments.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        if(cyclesData){
            cyclesData.map(cycle => {
                payments.map(payment => {
                    if(cycle.id == payment.cycle_id) {
                        payment.cycle_name = cycle.name
                    }
                })
            })
        }
        setDataTable(payments)
    }, [cyclesData, data])

    const onEditEvent = (record) => {
        navigate("/payment")
    }

    return <Card
        style={{
            marginTop: 4,
        }}
        type="inner"
        title="Payment History"
        loading={data.isLoading}
    >
        <List
            columnTable={customColumn}
            dataList={dataTable}
        />
    </Card>
}

export default PaymentComponent